"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgRotateCw = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M30.056 16.912l2.63 2.36a1 1 0 01-1.372 1.456l-2.651-2.381a8 8 0 101.884 8.32 1 1 0 111.886.666 10 10 0 11-14.258-12.088c3.901-2.15 8.754-1.462 11.88 1.667zM34 15a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 010-2h5v-5a1 1 0 011-1z",
    id: "rotate-cw_svg__a"
  }));
};

var _default = SvgRotateCw;
exports.default = _default;